import cs from "classnames";
import React from "react";

import { Preloader } from "src/common/components/Preloader";

import "./Button.css";

interface ButtonProps extends React.HTMLProps<HTMLButtonElement> {
	type: "submit" | "button";
	variant?: "primary" | "secondary" | "danger" | "icon";
	isLoading?: boolean;
}

export const Button: React.FunctionComponent<ButtonProps> = ({
	variant = "primary",
	isLoading,
	className,
	disabled,
	children,
	...props
}) => (
	<button
		{...props}
		disabled={disabled || isLoading}
		className={cs("button", `button--${variant}`, className, {
			"button--loading": isLoading
		})}
	>
		<div className="button__text">{children}</div>
		<div className="button__focus-indicator" />
		<div className="button__preloader-wrapper">
			<Preloader />
		</div>
	</button>
);
